var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{ref:"combobox",staticClass:"time-picker__select",attrs:{"value":_vm.value,"items":_vm.filteredItems,"menu-props":_vm.menuProps,"return-object":false,"filter":_vm.filter,"label":_vm.label,"disabled":_vm.disabled,"error":_vm.error,"placeholder":"−−:−−","append-icon":"","hide-details":""},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }